<template>
  <loading :loading="isLoading">
    <div class="scenic-detail">
      <div class="advertisement">
        <div class="slider" v-if="productDetail.images.length > 0">
          <swipe-comp :ads="productDetail.images" :show="swipeShow" :axiosObj='axiosObj' :showPhotoList='true' :typeOfBusiness='1' />
          <!-- 返回按钮 -->
          <img class="toBackImg" @click="goBack" src="https://cdn.133.cn/ticket/images/hangban/vue/hltrip/icon/home-back@2x.png" v-if="!['sinopec','wxapp-hbgj','boe','cnpc'].includes(hlsource)" />
        </div>
      </div>
      <div class="mainTitleWrap"></div>
      <div class="main-title">
        <div class="notice" v-if="productDetail.notice&&productDetail.notice[0]&&productDetail.notice.length>0" @click="openIntroduction">
          <notice-bar mode="link" :scrollable="true">
            <div slot="left-icon" class="left-icon">
              <img src="@/assets/detail/noticeIcon.png" alt="" class="noticeIcon" />
            </div>
            <div slot="default" class="default">
              <span v-for="(item, index) in productDetail.notice" :key="index">{{ item }}</span>
            </div>
            <div slot="right-icon" class="right-icon">
              <img src="@/assets/detail/noticeArrow.png" alt="" class="noticeArrow" />
            </div>
          </notice-bar>
        </div>
        <div class="title">
          <div class="title-left">{{ productDetail.name }}</div>
          <div class="title-right">
            <span @click="openIntroduction">详情</span><img src="@/assets/detail/blueArrow.png" alt="" />
          </div>
        </div>
        <div class="address" v-if="productDetail.address">
          <div class="address-left">{{ productDetail.address }}</div>
          <div class="address-right">
            <span @click="handleShowMap">地图</span><img src="@/assets/detail/blueArrow.png" alt="" />
          </div>
        </div>
      </div>
      <div class="sales" v-if="scenicSpotProductResult&&scenicSpotProductResult.length!=0">
        <div class="dateSelect">
          <div @click="isAnyTime" :class="isShowAnyTime ? 'item select' : 'item'">
            随订随用
          </div>
          <div v-for="(item,index) in priceDatePopup" :key="index+'priceDatePopup'" @click="selectDate(item, index+1)" :class="nowday == (index+1) ? 'item select' : 'item'">
            {{dateTransform(item.saleDate)}}
          </div>
          <!-- <div :class="nowday == 1 ? 'item select' : 'item'" @click="selectDate(TODAY, 1)">
            今日
          </div>
          <div :class="nowday == 2 ? 'item select' : 'item'" @click="selectDate(NEXTDAY, 2)">
            明日
          </div> -->
          <div :class="nowday > 2 && selectDateQuery ? 'item select' : 'item'" @click="showDatePrice">{{nowday>2&&selectDateQuery?dateTransform(selectDateQuery):'更多日期'}}</div>
        </div>
        <div class="packages" v-for="(item, index) in showScenicSpotProductResult" :key="index + item.groupTitle">
          <div class="packages-title">
            {{ item.groupTitle }}
          </div>
          <div class="packages-contain" v-for="(v, i) in item.group" :key="i + v.productId" @click="openPopup(v, index, i)">
            <div class="packages-contain-title">{{ v.ticketKindDesc }}{{ v.productName }}</div>
            <div class="refundTag">
              <span v-for="(a, b) in v.refundTag" :key="b + a.name" :style="txtColour(a.colour)">{{ a.name
                }}<span v-if="b + 1 != v.refundTag.length" class="divider">|</span></span>
            </div>
            <div class="bookTag">
              <span v-for="(a, b) in v.bookTag" :key="b + a.name" :style="txtColour(a.colour)">{{ a.name
                }}<span v-if="b + 1 != v.bookTag.length" class="divider" style="color:rgba(52,56,75,0.20);">|</span></span>
            </div>
            <div class="price">
              <div class="priceNumber">
                <del class="del" v-if="v.oriPrice">¥{{v.oriPrice}}</del><span>{{ v.pricePerfixed }}</span>{{ v.salePrice }}
              </div>
              <div class="saleButton" @click.stop="handleBook(index,i)">预订</div>
            </div>
          </div>
        </div>
      </div>
      <div class="introduction" v-if="productDetail.briefDesc">
        <div class="introduction-title">
          <span>简介</span>
          <div @click="openIntroduction">
            更多信息<img src="@/assets/list/arrow-right.png" alt="" />
          </div>
        </div>
        <div :class="showMoreBriefNote?'introduction-containMore':'introduction-contain'">
          <div ref="briefNote" v-html="productDetail.briefDesc"></div>
        </div>
        <div class="moreBtn" @click="moreBriefNote" v-if="!showMoreBriefNote">展开<img src="@/assets/detail/grownDownArrow.png" alt="" /></div>
      </div>
      <div class="recommendList" v-if="!['sinopec','boe','cnpc'].includes(hlsource)&&recommendList&&recommendList.length!=0">
        <div class="select">
          <div @click="recommendTypeClick(0)" :class="recommendType == 0 ? 'item select' : 'item'">
            同类推荐
          </div>
          <div @click="recommendTypeClick(1)" :class="recommendType == 1 ? 'item select' : 'item'">
            附近景点
          </div>
        </div>
        <div class="recommendList-item" v-for="(item, index) in recommendList" :key="index + item.scenicSpotId">
          <list-item :data="item" @jumpToOther="jumpToOther"></list-item>
        </div>
        <div class="wrap" v-if="isShowMore"></div>
        <div class="recommendList-foot" @click="showMorerecommendList" v-if="isShowMore">
          查看更多<img src="@/assets/list/arrow-right.png" alt="" />
        </div>
      </div>
      <hl-popup v-model="showPopup" position="bottom" round :style="{ height: '80%', bottom: '0' }" closeable>
        <div class="popup" :style="{ height: '80%' }">
          <div class="popup-title">{{ productDetail.name }}</div>
          <div class="popup-wrap"></div>
          <div class="popupcontainer">
            <div class="popup-contain">
              <div class="popup-contain-imgage">
                <swipe-comp :ads="productDetailPopup.images" v-if="showPopup" :height="171" />
              </div>
              <div class="popup-contain-page">
                <div class="noteDetail" v-for="(item, index) in productDetailPopup.noteDetail" :key="index + item.title">
                  <div class="noteDetail-title">{{ item.title }}</div>
                  <div class="noteDetail-contain" v-for="(v, i) in item.notes" :key="i">
                    <div class="noteDetail-contain-title" v-if="v.desc">
                      {{ v.title }}
                    </div>
                    <div class="noteDetail-contain-desc" v-if="v.desc" v-html="v.desc">
                    </div>
                    <div class="noteDetail-contain-single" v-if="!v.desc">
                      {{ v.title }}
                    </div>
                  </div>
                </div>
                <div class="serviceProvider">
                  -{{ productDetailPopup.serviceProvider }}-
                </div>
              </div>
            </div>
          </div>
          <div class="popup-fixed" v-if="showPopup">
            <div class="popup-fixed-contain">
              <div class="popup-fixed-contain-price">
                <span>{{
                scenicSpotProductResult[ticketIndex].group[setmealIndex]
                  .pricePerfixed
              }}</span>{{
                scenicSpotProductResult[ticketIndex].group[setmealIndex]
                  .salePrice
              }}
              </div>
              <div class="popup-fixed-contain-booking" @click="handleBook(ticketIndex,setmealIndex)">
                预订
              </div>
            </div>
            <div class="popup-fixed-wrap"></div>
          </div>
        </div>
      </hl-popup>
      <date-price ref="datePriceRef" :query="axiosObj" @confirm="datePriceHandleConfirm" />
      <date-price ref="datePriceBookRef" :query="axiosObjBook" @confirm="datePriceHandleConfirmBook" />
    </div>
  </loading>
</template>
<script>
import nativeApi from "@/utils/nativeApi";
import service from "@/service";
import get from "@/utils/get";
import env from "@/utils/env";
import swipeComp from "../components/swipe";
import { px2rem } from "@/projects/list/mixins";
import { NoticeBar, Toast } from "huoli-ui";
import listItem from "./components/scenic-item";
import datePrice from "@/projects/detail/components/date-price";
import loading from "@/components/c-loading.vue";
import moment from "moment";
import _ from "lodash";
export default {
  mixins: [px2rem],
  components: {
    swipeComp,
    NoticeBar,
    listItem,
    datePrice,
    loading,
  },
  data() {
    return {
      isShowMore: true, //是否有更多推荐
      axiosObjBook: {
        productId: "",
        startDate: "",
        endDate: "",
        scenicSpotId: this.$route.query.scenicSpotId,
        pid: "215049",
        packageId: "",
      }, //点击预定时价格日历请求参数
      hlsource: env.hlsource,
      showMoreBriefNote: false,
      ticketIndex: 0,
      setmealIndex: 0,
      nowday: 3,
      TODAY: moment().format("YYYY-MM-DD"),
      NEXTDAY: moment().add(1, "d").format("YYYY-MM-DD"),
      isLoading: true,
      swipeShow: false,
      selectDateQuery: "",
      selectPackageId: "",
      //价格日历请求参数

      //推荐列表类型
      recommendType: 0,
      //是否显示随订随用
      isShowAnyTime: false,
      //是否弹出产品预购层
      showPopup: false,
      //详情头部215044
      productDetail: {
        scenicSpotId: "",
        name: "",
        address: "",
        level: "",
        briefDesc: "",
        theme: "",
        images: [
          // "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBUVFRgSFRYYGBgYGBgaGBgZGBgYGBgYGBgZGRgYGBgcIS4lHB4rIRgYJjgmKy8xNTU1GiQ7QDszPy40NTEBDAwMEA8QGhISHjQkISE0NDQxNDQ0NDQ0MTQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NP/AABEIAKgBLAMBIgACEQEDEQH/xAAbAAABBQEBAAAAAAAAAAAAAAADAAECBAUGB//EADsQAAIBAgQDBQQJBAMAAwAAAAECAAMRBBIhMQVBURMiYXGBMpGh8AYUQlJiscHR4SNykvEVM6KCssL/xAAaAQADAQEBAQAAAAAAAAAAAAABAgMABAUG/8QAJxEBAQACAgIBBAICAwAAAAAAAAECESExAxJRBBRBYRMykbFScYH/2gAMAwEAAhEDEQA/AOECSapCqkIqTr287YSpCLTh0SFSnNsNgLThFpSylOHWjBsu1ZaMMlCXEpQ60Yu2UkoQy0JeWjCrRm2yilGWEw8tpShVpxbTRUWhJijLq05NaUTZopLRhFpS4KUItKC08iqlKFWjLSU4ZacS1SKq0ZNaEtpThVpxLVcYpjDyYw8vLTkxTiXJXHFnihF9Xmj2cfsolyUkZpw8Y0Jp9lItSiWqTFlNQg2ozWalBNSm2LKajBNRms1GBalDsKynpQTU5qPSgnpTbKzGSDNOaL0oFkh2FUSkiVltkg2SEFUrGyywUkMsIOVWnCrThkpwyU56bxdgpTh0pQyJDIkAXINKUOlOERIdKczeyCUodKcIiQyLFH2gaU4UJCKkKqQUdgpThVpwqJCqkS08CSnDCnJqIQCLapAckkqQ2WTVYlp5EFSTWnCKsKqxbVJEESFVJJVhEES1bGIqkmEkwsmFk7VcYGEkhThAskFi2qSBZJBkljLIlYu1FZkg2SXCkgUgBSanBNTl9kkGSHYM56UA9OaT04J0hlLWY9OBenNN6crukbYVmvTgXSaL04B0hhVBkg8kuOkHkhBziJDIkOtGHSlPW4fOXKq6JDJTlhKMsJSm4C5VXRIZEllaMKlKBplQUpwq04ZUhFSLTShKkIEhVSSCRapKFaSUwhpyOWJVJTiEWQUQiiJVsamBCIsiohlk6vjDqsIokRCLJ2rYxNRCKJBYQRKrIkBJARCOsW1WQ4ElFFEtUkKNaSEUVkCIxWEtFaYASsgyx8ViUprndgqiwufE2HxMmRMCuyQbJLTLBssIVTdJXdJfdIB0jQKoOkA6S+6QDpGhVB0gckuukCUhKxkSHRIlWFQT09vnbE0SHRJBFlhBAGiVIUJHAklEO29TBZJRJBZMLBs8hrRwJMJJBItp5EAsTJChJIJEtWxxAVJIJDinHyxLktjiEohFkssWWJatjDiEWCk1MSq40ZYQGCUyQMSqwYSQMGpkwYlVxqd48gDJCJVIlFFeKATwdaoEUseQJsNSbAk2HM2BkwZn8WwBqrlJUpbvK47twGysCNRqRfwA21voWvPfpPxbC1ayNQcu+ZsyF2RKqgm6hulwCCPEaTqPojxKs7PSxBzNo6NcWZLIpCKB7IO5Jvc89555x6olEVaQs7kqazoTUAIFu+SV3LICPiQLGP0Iwj08QXqF0qJoimm+Xv21zIGWx0vt7WhJOnZlhPRGW+z2siQYSaXsM1r2F7Xte2tr62jMJxqgMIJ1lhhBMIYVVdZXdZccQDiPKFU3WCKyy4grRisRIdJWRpYRp6T5+rSQqysrQqvMCyBCASurwgeYw6mFErK0KHiU0GEkBAh5MPFqkkFWEQQGaSV4lVxqxaK0GHkw0WrYntIkSWaMzRKpAmiVpF2kQ0zSrKmTBldHk80Wq40cNJBoEPHDSdWlWA0mDK6tCK0nVJRgYrwYaODFPBAZWx7OEbs1DN90kLcHfU6X567w4M57jXDKzt/TxDIjsC6M7KWF7sEc3yiwtl21hx1byGTzvjHF8QmIxNTss1I3puucMoLU7KVAUEdzLYhQLkAk6QtClUyviMGTSFYhHo01ftKZtmVRuym7XsAMy6+B0uO8Ear9fro7IwqUqdr5Cy9nhr5ilwwub2AtceJEhhcfW4ejVn/qtmyEI7WVRq7tTcBmBtowANwdSDc9u5cZrv4Q1d8u8+jWB7KgvfZy4VyzFr3Kj7LEleelyepM1GnH/Q76ZDFM1N1fMXYo+RsrITdVJAsCAbbm4Ukzr2M5MpZlypNWcItBMIVoJorWBOIBxLDwDxoCtUEDD1IAxpQculSWEeZKVJYSrPX0+caivCq8zUqw6VJtA0FeEV5QWrCLVi6HbQV4RXmetSEWrBYaVeDyQeUu2i7eLpSZL2eTFSZpxMQxMW4jM2qtST7WZAxMkMTBcVcc2t2sZqszlrx2rSdxVxyWWqRK8p9pJK8Fh5V9Xkw8oipJCpJ3FXHJeDxw8onEgWBIFzYX5noIVakSxSZLqvCq0oq8ItSTsVmS6Gj3lZHiNSJpWZLYeO1iNdeem/pbnKivJdtabQ7cRxKoXw+OCuyFsdSW4dEfV8Kl9BpY9SJv8HqlqPY4jNZf6eeqyulU/eVvaKkEalt9L6a8PxT6SU1SrSzWqPxHtNVZgiUqid4gDrTOmuxnUrj1fDPUC1AzLnLBXZiX079Jx3kNzysBcA3nTlL6zj8pyza19bp4GkRRpq69pqEqXylz3msS2UXNt+ew1mrwvHVKqhmRFFjmKuX74PsgZRpbW511Gk8wwfFOIUmRURmUjSmiZ6LjLopRu+La3a+9rz1LhruaKdqFV8i5wlwga2uUHUDw5Sfkx9f3s2N2tsYNjEzQbNI7PYTmBcyTNAu0MJYG5gYR2gLx5Q086TFCWExQ6zjRiz1hExp6mez7R4n27tUxY6wq4wdZxX18+MX/ACDdTN7RvtncDHL1khjx1nDjHN4ya4pzyM240+mdv/yI6xjxMdZxa4l+kc4l94Nw321dkeKDrEOJDrONNd7XtJpUfe83tG+2dj/yA6xxjx1nJLnPO0TuR9r01i+0H7Z144gOsdeJL1nIh2tcm3mf5gauKy7G/rp75ux/g072nxJOsJ/yCdZwOGNSp7Oi/eO3pLWMx40VWuV3br5df5iXHlXHx8O0+vL1k0xY6zg2xjC2up+RLOGxTPcX1tcePWJljqbUx8Vt1HbjFjrHGMXqJxRxDcifd+kcYhrbZhztoYlxP6Vq47jBeuipcqja6Hfa38zeHFEBsWF+l5xSVkG10PiL7+O8BUwzkmoHB6mwt6kXHvhuGN/Tetj0ReIDrDU8cOs85TFVFFiTqb5rZreVjLVHihNgG238ZLLxw09o9EXGCHp4oGcGnE22uPeNJvcBfOTmJP5SGePrNr4e1um5WxaKCSQANSSbADqTPPfpjxOpWYGmlQJT+3nKJmL5DYLq50FrG/eNra37DiaoO6VuGBBU63BnPPXVXZQgAJ1GUWbz6w+HKS7kNnjdcuDoVkemlBwQ7YnuuA5GV2s9hciwOX2e9PUeCcOJw7B8QWfvZXp5VCIy+yqFcujX3F9CJ5zRxF1pUwtyMTVcAEglVzGw5WuRt4ToaXEXU5kZhcEMSurKbZbjmQNL7+e06fLLeuEsNStRMWuGqVKdbEGoodGzZnQozENluqkC55Zhm72k3sP9KEdlC03ZHbKKigMgNiTn1BW1rG40Ok4avxmm+alXRlz6Zr2Dd7NbNoQCRz8pnU6rurojslNiTkF/bJJIubnLc8j/ADK+L27P766el4z6TUkbIMztqLUxn7wt3DbQMbi3n4Gaf1oW6TyvA56VTOrZQVUMFsASoI1B5a8povxxwd4mXh/4mnk+XoDYlesE1cdZwZ443WMeNHrF/hyH+TF3DVh1g+0E4teMG8spxVrbH3Ga+PKN7Y1xIwi7c/Nf3i+r22Av/Mze119qPnO9zO7WXy5Lcfhp8/ZXTlbe1jfWP2o52B8gP0matQ+PxEi7Hr8YZAtn4aqP4jTxlinX1tuPSYea0kr22E1m2mVjonqC19jysLi3iP1gMTWuBZf/AAPI7W085kiq/K/xiAc6k29bTY4aa52r/aXsAf8A0Rr1teNVcg6tf97+ImdkN7lrfH3QlKkz+yGPjyH7Smi27XXxLciYJ8W1gMx/f0Eu4PgbubG9z9lbkzTOHw+HHfYF/uIQzeTPsvxPhFtxnHdNMcryw6eGq1CND4XGvool0YWjR1cl3H2dyD48l+J8JDGccZgVQBF2su5H4nOp8tvCZlyY03e+B1J1yv4ribPoBlT7o/U84Gi1u8Qbch1kUQAZm9B1kKle5v8APpNJOoP7qb1WJvaGw1Rg6HlmAPkdD8Lyup0klfUW5ERcpuWGw4yla2KZwx0AsbHfde6T6kQD59xbzG81uLVB/UTL3lqFgdNVZFYjruZl9ob2kfFncsZdL+fCY52Shq7No1gev7yFWhUQ5gbHkRcfEQj8z+0jSxBXxHSW5/COp+Q/rb/bs3jYhv8AIWJPneTV0f7ZU9HXMP8ANRf/AMyRRX7ymU6lO001QssX0w7p3xcqOa2dPW17etpscN+k9ekLKlBx+IOD7wx/KctTqshzKSrdQSD7xLacUv8A9iK/4vYf/NbXP9wMTLxzKczZsc9dOvf6duR38Kmbqrlhtppa8zsf9Kqb3KUgrHmcxIPiNNpkI9J/YqZD92oDbyFRP1UR61B1GZ0zL99bOn+aXESeHDG8Q1ztnbK4KqO9R3NtWCHYqzsTcC/lOu4fxBAvZuiM631uVuORGmvz0nO5EO118QYqisbd8NbYnut6EaiNnj7BjZi6XE4+kf6YpWJ3IckqoIzEXG/IHkSN7SXb4f7jqLACxTS2ljtp/M5JabjWxA5kWe/mTrIds/I3trsAfdzi+k+R958Oprvhz9t1PiAbfGV2FAj/ALbdO6f0nNjGk7rY+OnmZoUELAMXUC2pzDbldd5vXX5DcvS5Rpo1++N9NN/W8guXMVVwT4i36wdTCqDpUUjQ6WB8TqbfGTfhwAuHBHIgFgSNx3b2g4+W1fhcw+Gzg6gaXv8AtfnK9Wg6nLc+l7Sv9XQMAXOvQMLeOo19BHGCB1LQa1+R/wDHJLTY+N4Tsnt+nhI9sbctIsx6mXc9ogTTW2+0ZTvpfb/UQU9b/POTDgc7fEzchyi1S2ySVOufLyjorNsCfE7S7R4fc9438BG67GS1TXE2NhcnpaWqWFd7aZR1O/umzw/hZYhUS53NunMluQ8fCW6tfD0PbbtHH2Kbd0H8VTUf4g+YiXOb1j2eeP8ANUsDwTMR3S7b66+tuk0KtShQ0dg7D7FNhYHoz+yPTNMXH8fqOCgsifcQWB/uPtOf7iZks/WaY5Zf2o7xx6bWO4+7gqncQ6ZEuAf7iTdvUzKLk7mCz8pNN5SYzHottoiJr+fhLCgLrv58vORZwABz9DKrVpuaPEFq1b85FBfSBDQ6ADaHovYqkR6bXMGx2tGQkEn8ouXR8e3Uccde3dTzRW87rb/8zHZufW00fpCL4gX50U620Zv3mI7/AGehOvhynP8ATc+PF0/VceXKLRe4uOfztAt1EZG0OpOlree0Zzpbw9fOdMctpZyDcaH3Xlrt1b2rXtM9nO0kWty+es1xaZC1F/Xn82lZ/fDJW6/PWKonPb+ek04a8q+a0nhsc6G6Oyn8LW99t4J1gGjcUvTZHFUf/tpqx++n9N/HVRlPqvrJilTfWlWAP3KoCN5BxdT6kTCvIh+UHrPw3t8tnELUpnvq635nVT5EaHziXEAjWx+PxlLC8RqJojkA7roVPmh0Pulk4yi//ZSyN9+icvvQ90+hESy/k0qPd22+fGKkQhvZW30It4ctzE2ELf8ARUV/wnuP5ZW39CZTr50OV1KnoQb/AB5QalbdjQfHBCCieefXztytCUsep72RB4XK+VtZkisOsXacotwhpm2xxI7Aub6WzFtOg1tI1MQpNzdTzGUftMO432/SE7R+p95g9ND7yqiW5/z744fp6CEp4Q85dpUAOkbiJTHammHZt9JdoYJRqQSZboYVn2AsPaYkBV82OkK2Mo0xp/UcdLpTH/y9pvgILn+IpMJOxcNg3Y2VSQLk7AL/AHMdBDVsTQpbntW+6hyoD+J928lHrMPGcWeoArGyDZFAVB4BR+Z1lINNMbf7NuTpr47jVSoCnsJvkQZEH9w3Y+JvMxjfXSDP5bxM2wlMcZOiXK1MN0+esZATIlYZKY+fyjbDRkQ7/P8AqHLBdvzjO4Gg5jfQ/l4QDsOX7wdj0TPv4++QB8PzkCf3j5oxRAdZYUgcr+vOAoi/zb55SYbnp5eMFGClwY45Wtv+shTPr4eulvjJUzcqPEeO7axcuj4c2Oxxjn63h7bFP0Yem8x/pDSArtfQGxPkQP1v7pc45Wy4nDsD0/8AsBIfSxe+hv7S/EHTl4zzPp7cc8P3LP8AFet9Vj7YeT9WX/MYgG9jcHa2p02/3GNvW/mfWMoIJHPXpf4eUiNfLn58/wDc9SPHpNr+1/GDLcvTpHZvyjM45H84xTCp8+m0KlUDQ8vz+TKrNy3t5ekRYHTxgsGVYcDl+/L3dYB1jJUI15x2INrm38TdCCRB2hHHKCJm2UrxZ5Bo2bxm2wgeXKXFKijKSHX7jjOo8r7elpmXizQWSjtqPUoPuppt1U5k9VOo9CYM4FyLoQ4H3TcjzXce6Ubx1qWNwbHqDrBr4babMQbG43vG7TxlgY4nRwHH4h3vRhrFagdbOPAZSPfBsWrQwzMM1gFG7sbJ7zv6XiqYykmiDtGHM3VB6bt62iikZzeVepwzsXxB39ttBsoFlHkolXN1iilZJE6UdXiihA9/n9oRRvrpy290UUzCJa23O17ev6RZ8uoY6bfsI8U0GhO19b6H3Dz8YK+nnFFGLSb58ok3/eKKEBlOnKwPrzjCpfr4RRQMJm7vqbdbD8pPB61E8WXryI/YRRRM/wCtU8f98f8AuN36VsAyEGxy6f5Aj9YuOY9HCFTcre+hANxtc+UUU5fp8JfH48r3Nu/6ryZTyeTGdXX+mIKt9dbEaW99j8I7bX312Pjzt+luUUU7a84JiL+HTfWORsf9evSKKFkCNfDcnnYyDHl87RRQFRzSLMBz+MUUzEXHr885FyD8+6KKZkIMxRTMYmKKKZik6NJnbKouelwNvMiPFAYccOqnXJ1+0vIkHn+E/JEScOqnUJp/cv7xRQM//9k=",
          // "data:image/jpeg;base64,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",
        ],
        coordinate: {},
        notice: [],
        scenicSpotOpenTimes: [],
      },
      //价格日历215049
      priceDatePopup: [],
      //套餐内容215047
      scenicSpotProductResult: [
        // {
        // groupTitle: "普通票",
        // group: [
        // {
        //   productId: "5006102",
        //   packageId: "5006104",
        //   saleDate: "2021-06-08",
        //   salePrice: 18.0,
        //   pricePerfixed: "¥",
        //   ticketKindDesc: "[园内其它]",
        //   category: "d_ss_ticket",
        //   anyTime: 0,
        //   productName:
        //     "河源佗城门票优待票(儿童/老人/学生票)河源佗城门票优待票(儿童/老人/学生票)河源佗城门票优待票(儿童/老人/学生票)",
        //   refundTag: [
        //     {
        //       name: "电子票",
        //       bkcolour: null,
        //       colour: null,
        //       bkrcolour: null,
        //     },
        //     {
        //       name: "限购99张/单",
        //       bkcolour: null,
        //       colour: "",
        //       bkrcolour: null,
        //     },
        //     {
        //       name: "随买随用",
        //       bkcolour: null,
        //       colour: null,
        //       bkrcolour: null,
        //     },
        //   ],
        //   bookTag: null,
        // },
        // {
        //   productId: "5006159",
        //   packageId: "5006161",
        //   saleDate: "2021-06-08",
        //   salePrice: 32.0,
        //   anyTime: 1,
        //   pricePerfixed: "¥",
        //   ticketKindDesc: "[成人票]",
        //   category: "d_ss_ticket",
        //   productName: "河源佗城门票成人票",
        //   refundTag: [
        //     {
        //       name: "电子票",
        //       bkcolour: null,
        //       colour: null,
        //       bkrcolour: null,
        //     },
        //     {
        //       name: "限购99张/单",
        //       bkcolour: null,
        //       colour: "",
        //       bkrcolour: null,
        //     },
        //     {
        //       name: "随买随用",
        //       bkcolour: null,
        //       colour: null,
        //       bkrcolour: null,
        //     },
        //   ],
        //   bookTag: null,
        // },
        //   ],
        // },
      ],
      //简介215046
      sceniceIntroduction: {
        images: null,
        briefNote: [
          {
            notes: [{}],
          },
        ],
        openTimeNote: [
          {
            title: "开放时间",
            notes: [
              {
                desc: "8:30--17:30;9:00--16:30",
                title: null,
              },
            ],
          },
        ],
        noteDetail: [],
      },
      //内容列表r215043
      recommendList: [],
      //产品详情215048
      productDetailPopup: {
        // images: [
        //   "data:image/jpeg;base64,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",
        //   "data:image/jpeg;base64,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",
        // ],
        // serviceProvider: "驴妈妈旅行社提供",
        // noteDetail: [
        //   {
        //     title: "预订须知",
        //     notes: [
        //       {
        //         desc: "出票后即时可用",
        //         title: "有效期",
        //       },
        //     ],
        //   },
        //   {
        //     title: "使用",
        //     notes: [
        //       {
        //         desc: "电子票",
        //         title: "票种",
        //       },
        //       {
        //         desc: "凭兑换凭证直接入园",
        //         title: "使用方式",
        //       },
        //     ],
        //   },
        //   {
        //     title: "退票",
        //     notes: [
        //       {
        //         desc: "一笔订单多张票不支持部分退票",
        //         title: "部分退",
        //       },
        //       {
        //         desc: "是否可改期：不支持改期\n改期规则：本产品暂不支持改期\n是否可退：可退\n退改说明：随时退：扣除每张（份）票价百分比（%）：0",
        //         title: "退票说明",
        //       },
        //     ],
        //   },
        // ],
      },
      coordinate: {},
      theme: "",
      recommendPage: {
        pageNo: 1,
        pageSize: "20",
      },
    };
  },
  computed: {
    axiosObj() {
      return {
        // productId: this.axiosObjProductId,
        startDate: "",
        endDate: "",
        scenicSpotId: this.$route.query.scenicSpotId,
        pid: "215049",
        // packageId: this.axiosObjPackageID,
      };
    },
    // axiosObjPackageID() {
    //   return _.get(
    //     this.scenicSpotProductResult,
    //     [this.ticketIndex, "group", this.setmealIndex, "packageId"],
    //     ""
    //   );
    // },
    axiosObjProductId() {
      return _.get(
        this.scenicSpotProductResult,
        [this.ticketIndex, "group", this.setmealIndex, "productId"],
        ""
      );
    },
    showScenicSpotProductResult() {
      if (this.isShowAnyTime) {
        return this.scenicSpotProductResult.map((item) => ({
          groupTitle: item.groupTitle,
          group: item.group.filter((v) => v.anyTime == 1),
        }));
      } else {
        return this.scenicSpotProductResult;
      }
    },
  },

  methods: {
    moreBriefNote() {
      this.showMoreBriefNote = true;
    },
    dateTransform(saleDate) {
      if (moment(saleDate).format("YYYY-MM-DD") == this.TODAY) {
        return `今天`;
      } else if (moment(saleDate).format("YYYY-MM-DD") == this.NEXTDAY) {
        return `明天`;
      } else {
        return moment(saleDate).format("MM-DD");
      }
    },
    jumpToOther(item) {
      // console.log(item);
      // this.isLoading = true;
      // this.swipeShow = false;
      const query = {
        scenicSpotId: item.scenicSpotId,
      };
      // const page = { path: "./scenic-detail", query };
      // // console.log("page", page, item);
      // this.$router.push(page);

      const page = {
        url: "/scenic-detail",
        name: "scenic-detail",
        query: query,
        params: {},
      };
      this.$page.push(page);
    },
    txtColour(colour) {
      return {
        color: `rgba(${colour})`,
      };
    },
    //点击预定时显示的价格日历
    showDatePriceBook() {
      this.$refs.datePriceBookRef.open({
        from: "more-price",
        // date: this.date,
        // productCode: this.productCode,
        // packageCode: this.packageCode,
        // productType: Number(this.productType),
      });
    },
    //确认预定时的价格日历
    datePriceHandleConfirmBook(res) {
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });
      this.selectDateQuery = moment(res.dateRes[0]).format("YYYY-MM-DD");
      this.selectPackageId = res.packageId;
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });
      if (env.isNative) {
        nativeApi.invoke("createWebView", {
          url: `${
            process.env.VUE_APP_BASE_URL_PAYMENT
          }/hangban/vue/hltrip/bookV2?analyseSourceEntry=${
            env.hlsource
          }&hlsource=${env.hlsource}&title=${
            this.productDetail.name
          }&productId=${
            this.scenicSpotProductResult[this.ticketIndex].group[
              this.setmealIndex
            ].productId
          }&packageId=${this.selectPackageId}&productType=2&startDate=${
            this.selectDateQuery
          }&category=d_ss_ticket`,
        });
        this.selectDateQuery = "";
      } else {
        // const a = document.createElement("a");
        // a.target = "_blank";
        location.href = `${
          process.env.VUE_APP_BASE_URL_PAYMENT
        }/hangban/vue/hltrip/bookV2?analyseSourceEntry=${
          env.hlsource
        }&hlsource=${env.hlsource}&title=${this.productDetail.name}&productId=${
          this.scenicSpotProductResult[this.ticketIndex].group[
            this.setmealIndex
          ].productId
        }&packageId=${this.selectPackageId}&productType=2&startDate=${
          this.selectDateQuery
        }&category=d_ss_ticket`;
        this.selectDateQuery = "";
      }
      Toast.clear();
    },
    handleBook(index, i) {
      this.ticketIndex = index;
      this.setmealIndex = i;
      if (this.selectDateQuery == "") {
        this.axiosObjBook = {
          productId:
            this.scenicSpotProductResult[this.ticketIndex].group[
              this.setmealIndex
            ].productId,
          startDate: "",
          endDate: "",
          scenicSpotId: this.$route.query.scenicSpotId,
          pid: "215049",
          packageId:
            this.scenicSpotProductResult[this.ticketIndex].group[
              this.setmealIndex
            ].packageId,
        };
        this.showDatePriceBook();
      } else {
        Toast.loading({
          duration: 0,
          message: "加载中...",
          forbidClick: true,
        });
        if (env.isNative) {
          nativeApi.invoke("createWebView", {
            url: `${
              process.env.VUE_APP_BASE_URL_PAYMENT
            }/hangban/vue/hltrip/bookV2?analyseSourceEntry=${
              env.hlsource
            }&hlsource=${env.hlsource}&title=${
              this.productDetail.name
            }&productId=${
              this.scenicSpotProductResult[this.ticketIndex].group[
                this.setmealIndex
              ].productId
            }&packageId=${
              this.scenicSpotProductResult[this.ticketIndex].group[
                this.setmealIndex
              ].packageId
            }&productType=2&startDate=${
              this.selectDateQuery
            }&category=d_ss_ticket`,
          });
        } else {
          // const a = document.createElement("a");
          // a.target = "_blank";
          location.href = `${
            process.env.VUE_APP_BASE_URL_PAYMENT
          }/hangban/vue/hltrip/bookV2?analyseSourceEntry=${
            env.hlsource
          }&hlsource=${env.hlsource}&title=${
            this.productDetail.name
          }&productId=${
            this.scenicSpotProductResult[this.ticketIndex].group[
              this.setmealIndex
            ].productId
          }&packageId=${
            this.scenicSpotProductResult[this.ticketIndex].group[
              this.setmealIndex
            ].packageId
          }&productType=2&startDate=${
            this.selectDateQuery
          }&category=d_ss_ticket`;
          // a.click();
        }
        // location.href = ;
        Toast.clear();
      }
    },
    //选择日期
    selectDate(res, index) {
      // this.nowday = index;
      let obj = {
        dateRes: [res.saleDate],
      };
      this.datePriceHandleConfirm(obj);
    },
    showMorerecommendList() {
      this.recommendPage.pageNo += 1;
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });
      if (this.recommendType == 0) {
        this.getRecommendList(
          // this.coordinate.longitude,
          // this.coordinate.latitude,
          "",
          "",
          this.theme,
          this.recommendPage
        ).then((data) => {
          // console.log("同类推荐", data, this.theme);
          if (data) {
            this.recommendList = this.recommendList.concat(data);
            this.isShowMore = true;
            Toast.clear();
          } else {
            this.isShowMore = false;
            Toast("暂无更多推荐信息");
          }
        });
      } else if (this.recommendType == 1) {
        this.getRecommendList(
          this.coordinate.longitude,
          this.coordinate.latitude,
          "",
          this.recommendPage
        ).then((data) => {
          // console.log(data);

          // console.log("附近推荐", data, this.coordinate);
          if (data) {
            this.recommendList = this.recommendList.concat(data);
            this.isShowMore = true;

            Toast.clear();
          } else {
            Toast("暂无更多推荐信息");
            this.isShowMore = false;
          }
        });
      }
    },
    //推荐列表选择
    recommendTypeClick(type) {
      this.recommendPage = {
        pageNo: 1,
        pageSize: "20",
      };
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });
      // console.log(type, this.coordinate.longitude, this.coordinate.latitude);
      if (type == 0) {
        this.getRecommendList(
          // this.coordinate.longitude,
          // this.coordinate.latitude,
          "",
          "",
          this.theme,
          this.recommendPage
        ).then((data) => {
          console.log("同类推荐", data, this.theme);
          this.recommendList = data;
          this.recommendType = type;
          Toast.clear();
        });
      } else if (type == 1) {
        this.getRecommendList(
          this.coordinate.longitude,
          this.coordinate.latitude,
          "",
          this.recommendPage
        ).then((data) => {
          console.log(data);
          console.log("附近推荐", data, this.coordinate);
          this.recommendList = data;
          this.recommendType = type;
          Toast.clear();
        });
      }
    },
    //时间选择器确认
    datePriceHandleConfirm(res) {
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });
      this.selectDateQuery = moment(res.dateRes[0]).format("YYYY-MM-DD");
      // console.log(
      //   this.selectDateQuery,
      //   moment(this.priceDatePopup[0].saleDate).format("YYYY-MM-DD")
      // );
      // if (this.selectDateQuery == this.TODAY) {
      //   this.nowday = 1;
      //   this.getScenicSpotProductResult(this.axiosObj.scenicSpotId, "").then(
      //     (data) => {
      //       console.log(data);
      //       this.scenicSpotProductResult = data || [];
      //       Toast.clear();
      //     }
      //   );
      // } else if (this.selectDateQuery == this.NEXTDAY) {
      //   this.nowday = 2;
      //   this.getScenicSpotProductResult(
      //     this.axiosObj.scenicSpotId,
      //     res.dateRes[0]
      //   ).then((data) => {
      //     console.log(data);
      //     this.scenicSpotProductResult = data || [];
      //     Toast.clear();
      //   });
      // } else {
      if (
        this.selectDateQuery ==
        moment(this.priceDatePopup[0].saleDate).format("YYYY-MM-DD")
      ) {
        this.nowday = 1;
      } else if (
        this.selectDateQuery ==
        moment(this.priceDatePopup[1].saleDate).format("YYYY-MM-DD")
      ) {
        this.nowday = 2;
      } else {
        this.nowday = 3;
      }
      this.getScenicSpotProductResult(
        this.axiosObj.scenicSpotId,
        res.dateRes[0]
      ).then((data) => {
        this.scenicSpotProductResult = data || [];
        Toast.clear();
      });
      // }
    },
    //点击更多日期
    showDatePrice() {
      this.$refs.datePriceRef.open({
        from: "more-price",
        // date: this.date,
        // productCode: this.productCode,
        // packageCode: this.packageCode,
        // productType: Number(this.productType),
      });
    },
    goBack() {
      // this.$router.back();
      if (env.hlsource === "sinopec"||env.hlsource === "cnpc") {
        window.location.href = "backtonative.html";
        return;
      } else {
        this.$page.back();
      }
    },
    //是否打开随订随用
    isAnyTime() {
      this.isShowAnyTime = !this.isShowAnyTime;
    },
    //打开预订
    openPopup(v, index, i) {
      this.ticketIndex = index;
      this.setmealIndex = i;
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });
      this.getProductDetailPopup(
        this.axiosObj.scenicSpotId,
        v.productId,
        v.packageId
      ).then((data) => {
        console.log(data);
        this.productDetailPopup = data;
        this.showPopup = true;
        Toast.clear();
      });
    },
    //打开详情
    openIntroduction() {
      const query = {
        title: this.productDetail.name,
        scenicSpotId: this.productDetail.scenicSpotId,
      };
      // const page = { path: "/scenic-introduction", query };
      // this.$router.push(page);

      const page = {
        url: "/scenic-introduction",
        name: "scenic-introduction",
        query: query,
        params: {},
      };
      this.$page.push(page);
    },
    // 查看地图
    handleShowMap() {
      // if (!this.productData.longitude || !this.productData.latitude) {
      //   return;
      // }
      // console.log("------------", this.productDetail.title);
      if (env.isNative) {
        nativeApi
          .invoke("showMap", {
            userLoc: true,
            name: this.productDetail.name,
            address: this.productDetail.address,
            lng: this.productDetail.coordinate.longitude,
            lat: this.productDetail.coordinate.latitude,
          })
          .catch(() => {});
      } else {
        location.href = `https://uri.amap.com/marker?position=${this.productDetail.coordinate.longitude},${this.productDetail.coordinate.latitude}&name=${this.productDetail.name}&coordinate=gaode&callnative=0`;
      }
    },
    // 详情头部215044
    getProductDetail(scenicSpotId, productId) {
      let obj = {
        scenicSpotId: scenicSpotId,
        productId: productId,
      };
      return service.r215044(obj).then((res) => get(res, "res.bd.data", []));
    },
    //简介215046
    getSceniceIntroduction(scenicSpotId, productId) {
      let obj = {
        scenicSpotId: scenicSpotId,
        productId: productId,
      };
      return service.r215046(obj).then((res) => get(res, "res.bd.data", []));
    },
    //内容列表r215043
    getRecommendList(longitude, latitude, theme, recommendPage) {
      let obj = {
        pageNo: recommendPage.pageNo,
        pageSize: recommendPage.pageSize,
        // depCity: LocalData.getOriginCity().cityName,
        // depCityCode: LocalData.getOriginCity().cityCode,
        // arrCity: pageCity.cityName,
        // arrCityCode: pageCity.cityCode,
        // arrCity: "广州",
        // arrCityCode: "440100000000",
        // longitude: this.getPosition.lng || null,
        longitude: longitude,
        latitude: latitude,
        // content: content,
        theme: theme,
      };
      return service.r215043(obj).then((res) => get(res, "res.bd.data", []));
    },
    //产品详情215048
    getProductDetailPopup(scenicSpotId, productId, packageId) {
      let obj = {
        scenicSpotId: scenicSpotId,
        productId: productId,
        packageId: packageId,
      };
      return service.r215048(obj).then((res) => get(res, "res.bd.data", []));
    },
    //套餐内容215047
    getScenicSpotProductResult(scenicSpotId, date) {
      let obj = {
        scenicSpotId: scenicSpotId,
        date: date,
      };
      return service.r215047(obj).then((res) => get(res, "res.bd.data", []));
    },
    // 价格日历215049
    getPriceDatePopup(scenicSpotId, productId, startDate, endDate) {
      let obj = {
        productId: productId,
        startDate: startDate,
        endDate: endDate,
        scenicSpotId: scenicSpotId,
      };
      return service.r215049(obj).then((res) => get(res, "res.bd.data", []));
    },
    initData() {
      this.isLoading = true;
      this.swipeShow = false;
      Promise.all([this.getProductDetail(this.axiosObj.scenicSpotId, "")]).then(
        (data) => {
          this.productDetail = data[0];
          this.coordinate = data[0].coordinate;
          this.theme = data[0].theme;
          // console.log({
          //   title: this.productDetail.name,
          //   imageUrl: this.productDetail.images[0], //显示图片地址
          //   path: `${process.env.VUE_APP_BASE_URL_PAYMENT}/hltrip/scenic-detail?scenicSpotId=${this.axiosObj.scenicSpotId}&hlsource=wxapp-hbgj`, //页面地址
          // });
          if (["wxapp-hbgj"].includes(this.hlsource)) {
            setTimeout(() => {
              env.miniProgramApi.postMessage({
                data: {
                  title: this.productDetail.name,
                  imageUrl: this.productDetail.images[0], //显示图片地址
                  path: `${process.env.VUE_APP_BASE_URL_PAYMENT}/hltrip/scenic-detail?scenicSpotId=${this.axiosObj.scenicSpotId}&hlsource=wxapp-hbgj`, //页面地址
                },
              });
            }, 600);
          }
          this.getScenicSpotProductResult(this.axiosObj.scenicSpotId, "").then(
            (data) => {
              this.scenicSpotProductResult = data || [];
              this.isLoading = false;
              this.swipeShow = true;
            }
          );
          this.getPriceDatePopup(this.axiosObj.scenicSpotId, "", "", "").then(
            (data) => {
              if (data.priceInfos) {
                this.priceDatePopup =
                  data.priceInfos.filter((item, index) => index < 2) || [];
                this.selectDateQuery = "";
              } else {
                this.priceDatePopup = [];
              }
              // console.log("priceDatePopup", this.priceDatePopup);
            }
          );
          // console.log("this.productDetail", data[0]);

          // console.log(data[0]);
          // console.log(data[2]);

          if (!["sinopec",'cnpc'].includes(this.hlsource)) {
            this.getRecommendList("", "", this.theme, this.recommendPage).then(
              (data) => {
                // console.log(data);
                this.recommendList = data;
                this.$nextTick(() => {
                  // console.log("this.$refs.briefNote", this.$refs.briefNote)
                  if (this.$refs.briefNote) {
                    if (this.$refs.briefNote.clientHeight < 66) {
                      this.showMoreBriefNote = true;
                    }
                  }
                });
              }
            );
          } else {
            this.$nextTick(() => {
              // console.log("this.$refs.briefNote", this.$refs.briefNote)
              if (this.$refs.briefNote) {
                if (this.$refs.briefNote.clientHeight < 66) {
                  this.showMoreBriefNote = true;
                }
              }
            });
          }
        }
      );
    },
  },
  beforeCreate() {
    if (env.isNative) {
      nativeApi.invoke("updateHeaderRightBtn", {
        action: "hide",
        icon: "",
        text: "",
        data: {},
      });
      nativeApi.invoke("setNavigationBarVisible", { value: "0" });
      nativeApi.invoke("setNavigationBarTintColor", { statusBarStyle: "1" });
    }
  },

  created() {
    console.log("------", this.hlsource);
    // this.initData();
    // 详情头部215044
    // this.getProductDetail(this.axiosObj.scenicSpotId, "").then((data) => {
    //   console.log("详情头部215044", data);
    // this.productDetail = data;
    // this.coordinate = data.coordinate;
    // this.theme = data.theme;
    // });
    //简介215046
    // this.getSceniceIntroduction(this.axiosObj.scenicSpotId, "").then((data) => {
    //   console.log("简介215046", data);
    //   this.sceniceIntroduction = data;
    // });
    //套餐内容215047
    // this.getScenicSpotProductResult(this.axiosObj.scenicSpotId, "").then(
    //   (data) => {
    //     console.log("套餐内容215047", data);
    //     this.scenicSpotProductResult = data;
    //   }
    // );
    // 价格日历215049
    // this.getPriceDatePopup(this.axiosObj.scenicSpotId, "", "", "").then(
    //   (data) => {
    //     console.log("价格日历215049", data);
    //   }
    // );
    //产品详情215048
    // getProductDetailPopup(
    // this.axiosObj.scenicSpotId,
    // productId,
    // packageId
    // ).then((data) => {
    //   console.log(data);
    // });
    //内容列表r215043
    // this.getRecommendList(
    // this.coordinate.longitude,
    // this.coordinate.latitude,
    // this.theme,
    // this.recommendPage
    // ).then((data) => {
    //   console.log(data);
    //   this.recommendList = data;
    // });
  },
  watch: {
    $route: {
      handler: "initData",
      immediate: true,
    },
  },
  beforeRouteLeave(to, from, next) {
    if (["wxapp-hbgj"].includes(this.hlsource)) {
      setTimeout(() => {
        env.miniProgramApi.postMessage({
          data: {},
        });
      }, 600);
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/_vars.scss";
.scenic-detail {
  position: relative;
  background: #f2f4f7;
  padding-bottom: 38 * $px;
}
.slider {
  position: relative;
  width: 375 * $px;
  height: 242 * $px;
  // margin-bottom: 121 * $px;
  .toBackImg {
    width: 28 * $px;
    height: 28 * $px;
    position: absolute;
    top: 52 * $px;
    left: 12 * $px;
    z-index: 2;
  }
}
.mainTitleWrap {
  position: absolute;
  left: 8 * $px;
  top: 230 * $px;
  right: 8 * $px;
  // width: 359 * $px;
  height: 15 * $px;
  background: #ffffff;
  border-top-left-radius: 12 * $px;
  border-top-right-radius: 12 * $px;
}
.main-title {
  // width: 359 * $px;
  // height: 128 * $px;
  background: #ffffff;
  border-bottom-left-radius: 12 * $px;
  border-bottom-right-radius: 12 * $px;
  box-sizing: border-box;
  margin-left: 8 * $px;
  margin-right: 8 * $px;
  padding: 0 12 * $px 12 * $px 12 * $px;
  margin-bottom: 12 * $px;

  .notice {
    width: 335 * $px;
    height: 34 * $px;
    border-radius: 6 * $px;
    margin-bottom: 8 * $px;
    .hl-notice-bar {
      width: 335 * $px;
      height: 34 * $px;
      border-radius: 6 * $px;
      padding: 0;
      .hl-notice-bar__wrap {
        height: 34 * $px;
      }
      .hl-notice-bar__content {
        height: 34 * $px;
        width: 180 * $px;
      }
      .default {
        font-size: 12 * $px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #ff6814;
      }
      .left-icon {
        margin: 0 12 * $px;

        .noticeIcon {
          width: 14 * $px;
          height: 12 * $px;
        }
      }
      .right-icon {
        margin: 0 12 * $px;
        .noticeArrow {
          width: 6 * $px;
          height: 9 * $px;
        }
      }
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12 * $px;
    &-left {
      display: flex;
      align-items: center;
      font-size: 20 * $px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #262626;
      // line-height: 28px;
    }

    &-right {
      display: flex;
      align-items: center;
      font-size: 12 * $px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #0078ff;
      // line-height: 17px;
      img {
        width: 4 * $px;
        height: 7 * $px;
        margin-left: 6 * $px;
      }
    }
  }
  .address {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12 * $px;
    &-left {
      display: flex;
      align-items: center;
      width: 272 * $px;
      font-size: 13 * $px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 400;
      color: #262626;
      // line-height: 28px;
    }

    &-right {
      display: flex;
      align-items: center;
      font-size: 12 * $px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #0078ff;
      // line-height: 17px;
      img {
        width: 4 * $px;
        height: 7 * $px;
        margin-left: 6 * $px;
      }
    }
  }
}
.sales {
  // width: 359 * $px;
  // height: 633 * $px;
  margin: 8 * $px;
  background: #ffffff;
  border-radius: 12 * $px;
  padding: 20 * $px 12 * $px 16 * $px 12 * $px;
  box-sizing: border-box;
  .dateSelect {
    display: flex;
    margin-bottom: 28 * $px;
    .item {
      background: #f8f9fb;
      border-radius: 17 * $px;
      padding: 6 * $px 12 * $px;
      font-size: 13 * $px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 400;
      margin-right: 8 * $px;
      color: #262626;
    }
    .select {
      background: #ebf5ff;
      color: #0078ff;
      font-weight: 500;
    }
  }
  .packages {
    // padding: 0 12 * $px;
    &-title {
      font-size: 17 * $px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #262626;
      margin-bottom: 16 * $px;
    }
    &-contain {
      width: 335 * $px;
      background: #f7f9fc;
      border-radius: 8 * $px;
      position: relative;
      margin-bottom: 8 * $px;
      padding: 16 * $px 12 * $px;
      box-sizing: border-box;
      &-title {
        font-size: 15 * $px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #262626;
        margin-bottom: 8 * $px;
        width: 206 * $px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .refundTag {
        margin-bottom: 4 * $px;
        span {
          font-size: 12 * $px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: rgba(52, 56, 75, 0.75);
        }
        .divider {
          margin: 0 6 * $px;
        }
      }
      .bookTag {
        height: 17 * $px;
        font-size: 12 * $px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #0078ff;
        .divider {
          margin: 0 6 * $px;
        }
      }
      .price {
        position: absolute;
        top: 21 * $px;
        right: 12 * $px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .priceNumber {
          font-size: 18 * $px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #ff6814;
          margin-bottom: 4 * $px;
          .del {
            font-size: 11 * $px;
            font-family: SFPro, SFPro-Regular;
            text-decoration: line-through;
            color: rgba(52, 56, 75, 0.5);
            margin-right: 2 * $px;
          }
          span {
            font-size: 12 * $px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #ff6814;
          }
        }
        .saleButton {
          width: 72 * $px;
          height: 28 * $px;
          background: linear-gradient(90deg, #ff9040, #ff5e19);
          border-radius: 16 * $px;
          font-size: 14 * $px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          line-height: 28 * $px;
        }
      }
    }
  }
}
.introduction {
  // width: 359 * $px;
  background: #ffffff;
  border-radius: 12 * $px;
  margin: 8 * $px;
  padding: 12 * $px 12 * $px 16 * $px 12 * $px;
  box-sizing: border-box;

  &-title {
    height: 25 * $px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18 * $px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #262626;
    }
    div {
      font-size: 12 * $px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: rgba(52, 56, 75, 0.5);
      display: flex;
      align-items: center;
      img {
        margin-left: 6 * $px;
        width: 4 * $px;
        height: 7 * $px;
      }
    }
  }
  &-contain {
    width: 335 * $px;
    font-size: 14 * $px;
    height: 66 * $px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #262626;
    line-height: 22 * $px;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
    margin-bottom: 6 * $px;
    div {
      width: 335 * $px;
      // white-space: pre-wrap;
    }
  }
  &-containMore {
    width: 335 * $px;
    font-size: 14 * $px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #262626;
    line-height: 22 * $px;
  }
  .moreBtn {
    height: 14 * $px;
    font-size: 14 * $px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: rgba(52, 56, 75, 0.5);
    line-height: 14px;
    img {
      width: 10 * $px;
      height: 6 * $px;
      display: inline-block;
    }
  }
}
.recommendList {
  // width: 359 * $px;
  margin: 0 8 * $px;
  background: #ffffff;
  border-radius: 12 * $px;
  padding-top: 20 * $px;
  .select {
    display: flex;
    margin-bottom: 12 * $px;
    .item {
      width: 76 * $px;
      height: 30 * $px;
      background: #f8f9fb;
      border-radius: 17 * $px;
      font-size: 13 * $px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #262626;
      margin-left: 8 * $px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .select {
      background: #ebf5ff;
      color: #0078ff;
      font-weight: 500;
    }
  }
  // &-item {
  // }
  .wrap {
    width: 343 * $px;
    height: 1 * $px;
    opacity: 1;
    margin: 0 auto;
    background: rgba(52, 56, 75, 0.1);
  }
  &-foot {
    height: 42 * $px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12 * $px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: rgba(52, 56, 75, 0.5);
    img {
      margin-left: 6 * $px;
      width: 4 * $px;
      height: 7 * $px;
    }
  }
}
.popup {
  position: relative;
  // padding-top: 57 * $px;
}
.popupcontainer {
  height: 100%;
  // border: 1px red solid;
  overflow-y: scroll;
  overflow-x: hidden;
}
.popup-title {
  width: 375 * $px;
  height: 57 * $px;
  text-align: center;
  line-height: 57 * $px;
  font-size: 18 * $px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #262626;
}
.popup-wrap {
  width: 375 * $px;
  height: 1 * $px;
  background: rgba(52, 56, 75, 0.1);
}
.popup-contain {
  padding: 16 * $px;
  padding-bottom: calc(90px + constant(safe-area-inset-bottom));
  padding-bottom: calc(90px + env(safe-area-inset-bottom));
  &-image {
    width: 343 * $px;
    height: 171 * $px;
    border-radius: 6 * $px;
  }
  &-page {
    margin-top: 16 * $px;
    .noteDetail {
      margin-bottom: 28 * $px;
      width: 343 * $px;
      &-title {
        height: 25 * $px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18 * $px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #262626;
        margin-bottom: 12 * $px;
      }
      &-contain {
        display: flex;
        margin-bottom: 4 * $px;
        // align-items: center;
        &-title {
          width: 88 * $px;
          font-size: 14 * $px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: rgba(52, 56, 75, 0.75);
          // margin-right: 16 * $px;
        }
        &-desc {
          width: 271 * $px;
          font-size: 14 * $px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #262626;
          line-height: 22 * $px;
        }
        &-single {
          width: 343 * $px;
          font-size: 14 * $px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #262626;
          line-height: 22 * $px;
        }
      }
    }
  }
  .serviceProvider {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12 * $px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: rgba(52, 56, 75, 0.3);
  }
}
.popup-fixed {
  opacity: 1;
  background: #ffffff;
  position: fixed;
  left: 0;
  bottom: 0;
  &-contain {
    width: 375 * $px;
    height: 64 * $px;
    background: #ffffff;
    padding: 10 * $px 16 * $px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-price {
      font-size: 20 * $px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: left;
      color: #ff6814;
      span {
        font-size: 14 * $px;
      }
    }
    &-booking {
      width: 246 * $px;
      height: 44 * $px;
      background: linear-gradient(90deg, #ff9040, #ff5e19);
      border-radius: 22 * $px;
      font-size: 18 * $px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &-wrap {
    width: 375 * $px;
    height: constant(safe-area-inset-bottom);
    height: env(safe-area-inset-bottom);
  }
}
</style>
